import Clearfix from 'components/elements/clearfix';
import React from 'react';
import FormRow from './FormRow';
import { LabelContainer } from './index';
import { FIELDS as FACILITY_FIELDS } from 'containers/Coso/CosoView/ChiTietCosoPanel/constants';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';
import { DATE_FORMAT } from 'config';
import { convertDateFromSever } from 'utils/fnUtil';
import _ from 'lodash';
import { InputGroup } from '@blueprintjs/core';
import { IS_ENTERPRISE } from 'config';

const InfoFacility = (props) => {
  const { getFieldValue } = props.form;

  let info = getFieldValue('facility');
  if (info) {
    info = info.obj;
  }

  const getValue = (field) => {
    const value = _.get(info, field, null);
    if (value) return value;
    return '';
  };

  return (
    <React.Fragment>
      <Clearfix height={8} />
      {!IS_ENTERPRISE && (
        <FormRow
          left={<LabelContainer>Tên doanh nghiệp</LabelContainer>}
          right={<InputGroup disabled value={getValue('organizationName')} />}
        />
      )}
      <FormRow
        left={<LabelContainer>Địa chỉ</LabelContainer>}
        right={<InputGroup disabled value={getValue('Address1')} />}
      />
      <FormRow
        left={<LabelContainer>Mã số QLCTNH</LabelContainer>}
        right={
          <InputGroup
            disabled
            value={getValue(FACILITY_FIELDS.reportHazardousWasteCode)}
          />
        }
      />
      <FormRow
        left={<LabelContainer>Ngày cấp</LabelContainer>}
        right={
          <DateInput
            formatDate={(date) => moment(date).format(DATE_FORMAT)}
            parseDate={(str) => moment(str).toDate()}
            disabled
            value={convertDateFromSever(
              getValue(FACILITY_FIELDS.reportHazardousWasteDate)
            )}
          />
        }
      />
      <FormRow
        left={<LabelContainer>Cấp lần</LabelContainer>}
        right={
          <InputGroup
            disabled
            value={getValue(
              FACILITY_FIELDS.reportHazardousWasteAllocationTimes
            )}
          />
        }
      />
      <FormRow
        left={<LabelContainer>Ngày cấp lại</LabelContainer>}
        right={
          <DateInput
            formatDate={(date) => moment(date).format(DATE_FORMAT)}
            parseDate={(str) => moment(str).toDate()}
            disabled
            value={convertDateFromSever(
              getValue(FACILITY_FIELDS.reportHazardousWasteDateRenew)
            )}
          />
        }
      />
      <FormRow
        left={<LabelContainer>Hình thức xử lý</LabelContainer>}
        right={
          <InputGroup
            disabled
            value={_.get(
              info,
              [FACILITY_FIELDS.reportHazardousWasteFormProcessing, 'Name'],
              ''
            )}
          />
        }
      />
      <FormRow
        left={<LabelContainer>Khối lượng đăng ký (kg)</LabelContainer>}
        right={
          <InputGroup
            disabled
            value={getValue(FACILITY_FIELDS.reportHazardousWasteMass)}
          />
        }
      />
    </React.Fragment>
  );
};

export default InfoFacility;



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportForm/InfoFacility.js